@if (
  (isLofiReportAvailable$ | async) ||
  shapesLength >= 0 ||
  (showSummaryStatsReport && summaryStatsReportAvailable)
) {
  <div class="locator-reports-root">
    @if (
      showSummaryStatsReport &&
      summaryStatsReportAvailable &&
      shapesLength === 0
    ) {
      <div>
        <div class="summary-text" i18n="@@summaryUnavailable">
          Summary information is currently unavailable. Please select one
          catchment to see the summary information.
        </div>
      </div>
    } @else {
      @if (shapesLength > 1 && !(isLofiReportAvailable$ | async)) {
        <div>
          <span style="font-size: 12px" i18n="@@multipleCatchmentsSelected">
            Multiple catchments selected. Please select one catchment to see the
            summary stats.
          </span>
        </div>
      }
      @if ((isLofiReportAvailable$ | async) || shapesLength === 1) {
        <div class="report-section">
          @if (!selectedQueryItem) {
            @if (!(isLofiReportAvailable$ | async)) {
              <div i18n="@@noDataAvailable">
                There is no data available for the selected catchment.
              </div>
            } @else {
              <div class="spinner">
                <mat-spinner diameter="24" strokeWidth="2"> </mat-spinner>
              </div>
            }
          }

          @if (selectedQueryItem) {
            <div
              class="image-container"
              [class.no-panel-header]="queryItems.length <= 1 && !titleType"
            >
              @if (!(isReportDataAvailable$ | async) && shapesLength === 1) {
                <div i18n="@@noDataAvailable">
                  There is no data available for the selected catchment.
                </div>
              } @else {
                @if (queryItems.length > 1) {
                  <div style="display: flex; align-items: center; padding: 4px">
                    <div
                      style="flex: 1; text-align: center; margin-left: 25px"
                      id="{{ identifier }}"
                    >
                      @for (row of queryItems; track row; let i = $index) {
                        <span
                          class="dot"
                          [ngClass]="{ ' active': i === 0 }"
                          (click)="selectQuery(i)"
                          i18n="@@queryItemSelection"
                        >
                        </span>
                      }
                    </div>
                  </div>
                }
                @if (titleType) {
                  <div style="text-align: center" i18n="@@titleType">
                    {{ titleType }}
                  </div>
                }
                @if (isAiAssistantEnabled$ | async) {
                  <div class="ai-button">
                    <button
                      matSuffix
                      mat-icon-button
                      color="primary"
                      class="icon button"
                      (click)="onAiAssistantClicked()"
                    >
                      <span class="material-symbols-outlined"
                        >auto_awesome</span
                      >
                    </button>
                  </div>
                }
                @if (selectedQueryItem.isStats) {
                  <atlas-locator-reports-stats
                    class="report-content"
                    [queryItem]="selectedQueryItem"
                  >
                  </atlas-locator-reports-stats>
                }
                @if (selectedQueryItem.isGraph) {
                  <atlas-locator-reports-graph
                    class="report-content"
                    [pieGridView]="pieGridView"
                    [numberCardView]="numberCardView"
                    [height]="graphHeight"
                    [queryItem]="selectedQueryItem"
                    [graphConfig]="graphConfig"
                    (graphClicked)="onGraphClicked($event)"
                  >
                  </atlas-locator-reports-graph>
                }
              }
            </div>
          }
        </div>
      }
    }
  </div>
}
